import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Breakpoints } from '../../utils';
import 'slick-carousel/slick/slick.css';
import StyledStreamSlider from './StreamSlider.style';

const DEFAULT = {
  dots: false,
  arrows: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: Breakpoints.computerBreakpoint,
      settings: {
        centerMode: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: Breakpoints.wideMobileBreakpoint,
      settings: {
        centerMode: false,
        centerPadding: '32px',
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const StreamSlider = ({ children, height, theme, options = {} }) => {
  const settings = { ...DEFAULT, ...options };
  const sliderCSS = cn(
    'streamslider',
    theme && `streamslider--${theme}`,
    { 'streamslider--align': height === 'align' },
    { 'streamslider--arrows': settings.arrows }
  );
  return (
    <StyledStreamSlider {...settings} className={sliderCSS}>
      {children}
    </StyledStreamSlider>
  );
};

StreamSlider.propTypes = {
  children: PropTypes.node,
  height: PropTypes.string,
  theme: PropTypes.string,
  options: PropTypes.object
};
StreamSlider.defaultProps = {
  height: 'align'
};
export default StreamSlider;
